export default "__VITE_ASSET__CUJHuIoTqlZPZnd$CSWT8g__";